import script from "./WegowLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowLoader.vue?vue&type=script&setup=true&lang=js"

import "./WegowLoader.vue?vue&type=style&index=0&id=258533b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258533b2"]])

export default __exports__